/* import __COLOCATED_TEMPLATE__ from './bridge-chart-analyze.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type AppService from 'embercom/services/app-service';
import type ReportingAgentSidebarService from 'embercom/services/reporting-agent-sidebar';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type ApplicationInstance from '@ember/application/instance';
import { registerDestructor } from '@ember/destroyable';
import { captureException } from 'embercom/lib/sentry';

interface Signature {
  Args: {};
}

export default class ReportingCustomReportBridgeChartAnalyze extends Component<Signature> {
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare reportingAgentSidebar: ReportingAgentSidebarService;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  constructor(owner: ApplicationInstance, args: {}) {
    super(owner, args);
    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'reporting:chart:analyze',
      (data: { chartId: string; dateRange?: { start: number; end: number; timezone: string } }) => {
        this.openSidebar(data.chartId, data.dateRange);
      },
    );

    registerDestructor(this, () => {
      unsubscribe();
    });
  }

  private openSidebar(
    chartId: string,
    dateRange?: { start: number; end: number; timezone: string },
  ) {
    let chart = this.store.peekRecord('reporting/custom/chart', chartId);
    if (!chart) {
      captureException(new Error(`BridgeChartAnalyze: chart ${chartId} not found in store`), {
        tags: {
          feature: 'custom_reports',
          component: 'BridgeChartAnalyze',
          responsible_team: 'team-reporting',
        },
        extra: { chartId },
        fingerprint: ['bridge-chart-analyze-missing-chart'],
      });
      return;
    }

    let reportState = {
      dateRange: dateRange ?? chart.dateRange,
      timezone: dateRange?.timezone ?? this.appService.app?.timezone ?? 'UTC',
    };

    if (this.reportingAgentSidebar.isOpen) {
      this.reportingAgentSidebar.addChart(chart, reportState);
    } else {
      this.reportingAgentSidebar.openWithChart(chart, reportState);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::BridgeChartAnalyze': typeof ReportingCustomReportBridgeChartAnalyze;
    'reporting/custom/report/bridge-chart-analyze': typeof ReportingCustomReportBridgeChartAnalyze;
  }
}
